"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonNotifications_en_us = void 0;
function commonNotifications_en_us() {
    return {
        "notifications.title": "Notifications",
        "notifications.empty": "Over here you can find current notifications. Nothing new right now.",
        "notifications.confirmation.title": "Confirmation",
        "notifications.warning.title": "Warning",
        "notifications.error.title": "Error",
        "notifications.error.message": "An error occurred!",
        "notifications.success.title": "Success",
        "notifications.added.title": "Successfully added.",
        "notifications.deleted.title": "Successfully deleted.",
        "notifications.edited.title": "Successfully edited.",
        "notifications.markedasdone.title": "Successfully marked as done.",
        "notifications.markedasopen.title": "Successfully marked as open.",
        "notifications.favorites.added": "Added to favorites.",
        "notifications.favorites.removed": "Removed from favorites."
    };
}
exports.commonNotifications_en_us = commonNotifications_en_us;
